export default "__VITE_ASSET__1bdc9b99__"